/* ============================================================================
   Admin module route registration.
   Self-registers the /admin route + an "Admin" nav item, visible and accessible
   only to Admin / SystemAdmin. No shared/spine file is edited.
   ============================================================================ */

import { registerRoute } from '../../app/registry';
import AdminArea from './AdminArea';

registerRoute({
  path: '/admin',
  element: <AdminArea />,
  nav: { label: 'Admin', section: 'Admin', order: 90, icon: '⚙' },
  roles: ['Admin', 'SystemAdmin'],
});
